import React from 'react';
import { EVENTS } from 'shared/constants/analytics';
import { useAnalyticsImpression } from 'src/hooks/analytics/use-analytics-impression';
import styles from './calendar-widget.module.scss';

const CalendarWidget = React.memo(function CalendarWidget({ title = '', url }) {
  const { ref } = useAnalyticsImpression({ event: EVENTS.WIDGETS.CALENDAR.IMPRESSION });

  if (!url) {
    return null;
  }

  return (
    <>
      <label className={styles.title}>{title}</label>
      <div ref={ref} className={styles.calendar}>
        <iframe title={title} src={url} />
      </div>
    </>
  );
});

export { CalendarWidget };
